import { i18nClient, useTranslation } from '@sailor/i18n-web'
import { getI18nWebParams } from '@sailor/i18n-utils'
import ChainedBackend from 'i18next-chained-backend'
import OpenAPIBackend from '@sailor/i18n-web-openapi-backend'
import { envs } from './env'
// import locale from '@roo/roo/locale'
// import zhHK from '@roo/roo/locale/lang/zh-TW'
// import zh from '@roo/roo/locale/lang/zh-CN'
// import ar from '@roo/roo/locale/lang/ar'
// import en from '@roo/roo/locale/lang/en-US'
// import locale_plus from '@roo/roo-plus/locale'
// import zhHK_plus from '@roo/roo-plus/locale/lang/zh-TW'
// import zh_plus from '@roo/roo-plus/locale/lang/zh-CN'
// import en_plus from '@roo/roo-plus/locale/lang/en-US'
// import ar_plus from '@roo/roo-plus/locale/lang/ar'
// import dayjs from 'dayjs'
import i18nConfig from '../../../i18n.config.json'
import { getLocalInfo, getRegion, updateLocalInfo } from './i18nFuncs'

const i18nEnv = envs.isTest ? 'test' : 'prod'

const SUPPORTED_LANG = ['en', 'zh-HK']

function initLanguage () {
  let lang = 'en' // 默认英语
  const sessionLang = localStorage.getItem('i18nLocale') || ''
  const urlLocale = new URLSearchParams(window.location.search).get('locale') || ''
  if (SUPPORTED_LANG.includes(urlLocale)) { // 链接中有语言,存至本地
    lang = urlLocale
    // 移除链接中的参数locale参数
    const url = new URL(window.location.href)
    url.searchParams.delete('locale')
    window.history.replaceState({}, '', url.toString())

  } else if (SUPPORTED_LANG.includes(sessionLang)) { // 当前页面已有语言
    lang = sessionLang
  }
  updateLanguage(lang)
}


export const getLanguage = () => localStorage.getItem('i18nLocale') || 'en'

export const updateLanguage = (lang: string) => {
  document.title = lang === 'zh-HK' ? 'Keeta for Business - 企業首選的餐飲津貼與報銷管理解決方案' : 'Keeta for Business - The Premier Solution for Meal Allowance and Expense Management'
  localStorage.setItem('i18nLocale', lang)
}

export function useLang () {
  const { i18n } = useTranslation()
  return i18n.language

}

export function getI18nParams () {
  const { region = 'HK', timeZone = 'GMT+08:00' } = getLocalInfo()
  return {
    locale: getLanguage(),
    region,
    timeZone,
  }
}


export default async function initI18n (cb) {
  initLanguage() // 初始化语言
  const defaultLang = getLanguage()
  // fetchResourceJson(i18nEnv) // 预加载资源包
  const i18nWebParams =
    (await getI18nWebParams({
      clientType: 'b_pc',
      env: i18nEnv,
    })) || {}

  const { localInfo = {} } = i18nWebParams

  updateLocalInfo({ // 缓存local信息
    i18nLocalInfo: localInfo,
    region: getRegion() ||  localInfo.region,
    timeZone: localInfo.timeZone,
    locale: defaultLang,
  })
  // dayjs.locale(defaultLang) // dayjs的语言名可能不一致
  i18nClient.use(ChainedBackend).init({
    // 设置回退语言
    fallbackLng: defaultLang,
    supportedLngs: ['zh-HK', 'en', 'zh'],
    ns: i18nConfig.namespaces.map((v) => v.name), // 当使用多个空间名称时，必须配置 ns，且第一个为默认空间名
    defaultNS: i18nConfig.namespaces.map((v) => v.name)[0], // 设置默认空间名称
    backend: {
      backends: [
        OpenAPIBackend, // 通过api获取最新语言包
        // resourcesToBackend(resources), // 本地资源包作为兜底
      ],
      // 这里配置一下所使用的projectId和namespaceId
      backendOptions: [{ ...i18nConfig, env: i18nEnv }],
      cacheOptions: {
        openClearOldLanguagePackage: true,
      },
    },
  }, function () {
    // const langs = {
    //   roo: { 'zh-HK': zhHK, 'zh-CN': zh, zh: zh, en: en, ar },
    //   rooPlus: { 'zh-HK': zhHK_plus, 'zh-CN': zh, zh: zh_plus, en: en_plus, ar: ar_plus },
    // }
    // locale.use(langs.roo[defaultLang])
    // locale_plus.use(langs.rooPlus[defaultLang])
    cb() // 做一些初始化工作
  }
  )
}